//#region imports
import { Injectable } from '@angular/core';
import { ProgressBarService } from './progressbar.service';
import { mobileProgressBarModel, ProgressBarModel } from '../shared/model/progressbar.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { RecapitulatoryComponentModel } from '../module/recapitulatory/model/recapitulatory.model';
//#endregion

@Injectable({
  providedIn: 'root'
})
export class SummaryService {
  //#region variables
  capitalContentWarningStatus = false;
  recapitulatoryComponent = new BehaviorSubject<RecapitulatoryComponentModel>(null);
  //#endregion

  //#region methods
  constructor(private progressBarService: ProgressBarService) { }

  setCapitalContentWarningStatus(value: boolean) {
    this.capitalContentWarningStatus = value;
  }

  getCapitalContentWarningStatus(): boolean {
    return this.capitalContentWarningStatus;
  }

  setRecapitulatoryComponent(value: RecapitulatoryComponentModel) {
    this.recapitulatoryComponent.next(value);
  }

  getRecapitulatoryComponent(): Observable<RecapitulatoryComponentModel> {
    return this.recapitulatoryComponent.asObservable();
  }

  setRecapitulatoryCurrentPage(firstComponent: boolean, secondComponent: boolean) {
    const recapitulatoryComponent = {
      RecapitulatoryQuestion1: firstComponent, RecapitulatoryQuestion2: secondComponent
    };
    this.setRecapitulatoryComponent(recapitulatoryComponent);
  }

  setRecapitulatoryCurrentComponent(firstComponent: boolean, secondComponent: boolean) {
    const recapitulatoryComponent = {
      RecapitulatoryQuestion1: firstComponent, RecapitulatoryQuestion2: secondComponent
    };
    this.setRecapitulatoryComponent(recapitulatoryComponent);
  }

  setSummaryProgressBarDetails() {
    const characteristicsProgressStatus: ProgressBarModel = {
      Disable: false, Number: false, Icon: true
    };
    const detailsProgressStatus: ProgressBarModel = {
      Disable: false, Number: false, Icon: true
    };
    const guaranteeProgressStatus: ProgressBarModel = {
      Disable: false, Number: false, Icon: true
    };
    const summaryProgressStatus: ProgressBarModel = {
      Disable: false, Number: false, Icon: false
    };
    const signatureProgressStatus: ProgressBarModel = {
      Disable: true, Number: true, Icon: false
    };
    this.progressBarService.setCharacteristicsProgressStatus(characteristicsProgressStatus);
    this.progressBarService.setDetailsProgressStatus(detailsProgressStatus);
    this.progressBarService.setGauranteeProgressStatus(guaranteeProgressStatus);
    this.progressBarService.setSummaryProgressStatus(summaryProgressStatus);
    this.progressBarService.setSignatureProgressStatus(signatureProgressStatus);
  }

  setmobileSummaryProgressBarDetails() {
    const characteristicsProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const detailsProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const guaranteeProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const summaryProgressStatus: mobileProgressBarModel = {
      Enable: true
    };
    const signatureProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    this.progressBarService.setmobileCharacteristicsProgressStatus(characteristicsProgressStatus);
    this.progressBarService.setmobileDetailsProgressStatus(detailsProgressStatus);
    this.progressBarService.setmobileGauranteeProgressStatus(guaranteeProgressStatus);
    this.progressBarService.setmobileSummaryProgressStatus(summaryProgressStatus);
    this.progressBarService.setmobileSignatureProgressStatus(signatureProgressStatus);
    if (document.getElementById("tab1") !== null && document.getElementById("tab1") !== undefined 
    && document.getElementById("tab2") !== null && document.getElementById("tab2") !== undefined
    && document.getElementById("tab3") !== null && document.getElementById("tab3") !== undefined
    && document.getElementById("tab4") !== null && document.getElementById("tab4") !== undefined
    && document.getElementById("tab5") !== null && document.getElementById("tab5") !== undefined ){
    document.getElementById("tab1").classList.remove("d-none");
    document.getElementById("tab2").classList.remove("d-none");
    document.getElementById("tab3").classList.remove("d-none");
    document.getElementById("tab5").classList.remove("d-none");
    document.getElementById("tab4").querySelector(".panel-heading").classList.remove("d-none");
    }
  }
  //#endregion
}
